import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EErgoHome } from '../../models/e-ergo/e-ergo-home.model';
import { NewForm } from '../../models/e-ergo/new-form.model';
import { User } from '../../models/user/user.model';
import { EErgoFormService } from '../../services/e-ergo-form.service';
import { EErgoRequestFormConfigService } from '../../services/e-ergo-request-form-config.service';
import { Base } from '../base/base';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'e-ergo-home',
  templateUrl: './e-ergo-home.component.html',
  styleUrls: ['./e-ergo-home.component.css'],
  providers: [EErgoRequestFormConfigService]
})
export class EErgoHomeComponent extends Base implements OnInit, OnDestroy {
  private BusyA;
  private BusyB;
  private BusyC;
  private BusyD;

  public pageName = "EErgoHome";

  home: EErgoHome;

  evaluationForChoices = [
    {
      'value': false,
      'text': 'Self'
    },
    {
      'value': true,
      'text': 'On Behalf Of'
    }
  ];

  templateChoices = [
    {
      'value': 'office-ergonomics',
      'text': 'Office Ergonomics'
    },
    {
      'value': 'manual-material-handling',
      'text': 'Manual Material Handling'
    }
  ];

  choices = [
    {
      'value': false,
      'text': 'No'
    },
    {
      'value': true,
      'text': 'Yes'
    }
  ];

  forms: any;
  prevContinuationTokens: any = [];
  nextContinuationToken: string;
  public industry: string = '';

  officeErgoQuest1Val;

  constructor(private eErgoFormService: EErgoFormService, private router: Router,
    private titleService: Title) {
    super();
    this.titleService.setTitle(this.basePageTitle + this.pageName);
  }

  ngOnInit(): void {
    this.industry = this.getIndustry();
    this.user = this.getUserDetailsFromLocalStorage();
    this.home = {
      employeeName: this.user ? this.user.name : '',
      onBehalfOf: this.evaluationForChoices[0].value,
      step: 1,
      type: this.templateChoices[0].value,
      changesMade: this.choices[0].value,
      furtherAssessmentRequired: this.choices[0].value
    }
  }

  public changeEvaluationFor() {
    if (this.home.onBehalfOf) {
      this.home.employeeName = '';
    } else {
      this.home.employeeName = this.user.name;
    }
  }

  public nextStep() {
    switch (this.home.step) {
      case 1:
        this.getOpenForms();
        this.home.step++
        break;
      case 2:
        this.getEErgoTrainingStatus(this.user.emailAddress) ? this.home.step += 2 : this.home.step++;
        break;
      case 3:
        this.setEErgoTrainingStatus(this.user.emailAddress, true);
        this.home.step++;
        break;
      default:
        this.home.step++;
    }
  }

  public getOpenForms() {
    let employeeEmailAddress = this.home.onBehalfOf ? '' : this.user.emailAddress;

    this.BusyB = this
      .eErgoFormService
      .getOpenFormsForEmployee(this.home.type, this.user.emailAddress, this.home.employeeName, employeeEmailAddress, this.nextContinuationToken)
      .subscribe(result => {
        this.forms = result.Item1;
        this.nextContinuationToken = result.Item2;
      });
  }

  public prevPage() {
    let employeeEmailAddress = this.home.onBehalfOf ? '' : this.user.emailAddress;
    this.prevContinuationTokens.pop();

    this.BusyC = this
      .eErgoFormService
      .getOpenFormsForEmployee(this.home.type, this.user.emailAddress, this.home.employeeName, employeeEmailAddress, this.nextContinuationToken)
      .subscribe(result => {
        this.forms = result.Item1;
        this.nextContinuationToken = result.Item2;
      });
  }

  public nextPage() {
    let employeeEmailAddress = this.home.onBehalfOf ? '' : this.user.emailAddress;

    this.BusyC = this
      .eErgoFormService
      .getOpenFormsForEmployee(this.home.type, this.user.emailAddress, this.home.employeeName, employeeEmailAddress, this.nextContinuationToken)
      .subscribe(result => {
        this.prevContinuationTokens.push(this.nextContinuationToken);
        this.forms = result.Item1;
        this.nextContinuationToken = result.Item2;
      });
  }

  public gotoForm(templateName: string, formId: string) {
    this.router.navigate([`/${templateName}`, formId]);
  }

  public createNewForm() {
    let newForm: NewForm = {
      companyName: this.user.companyName,
      contactPerson: this.user.name,
      emailAddress: this.user.emailAddress,
      employeeName: this.home.employeeName,
      onBehalfOf: this.home.onBehalfOf,
      phone: this.user.phone,
      policyNumber: this.user.policyNumber,
      type: this.home.type
    };

    this.BusyA = this.eErgoFormService.createForm(newForm).subscribe(response => {
      this.router.navigate([`/${this.home.type}`, response.id]
      );
    });
  }

  ngOnDestroy(): void {
    if (this.BusyA) {
      this.BusyA.unsubscribe();
    }

    if (this.BusyB) {
      this.BusyB.unsubscribe();
    }

    if (this.BusyC) {
      this.BusyC.unsubscribe();
    }

    if (this.BusyD) {
      this.BusyD.unsubscribe();
    }
  }
}

